import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';

import usePaths from 'src/hooks/use-paths';
import useUI from 'src/hooks/use-ui';

import { AnchorButton } from 'src/components/core/button/anchor-button';

export const LoggedIn = (): JSX.Element => {
  const { href: baseHref } = usePaths();
  const { closeCartDrawer } = useUI();

  return (
    <Wrapper>
      <Link href={baseHref}>
        <AnchorButton href={baseHref} onClick={closeCartDrawer} data-testid='go-to-homepage-button'>
          Go to Homepage
        </AnchorButton>
      </Link>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-top: 24px;
`;
